import * as yup from "yup"
import type { Resource } from "../../types"

export function initialValuesResource(resource?: Resource | undefined) {
  if (resource) {
    return resource
  }
  return {
    title: "",
    typology: null,
  }
}

export function validationSchemaResource() {
  return yup.object().shape({
    title: yup.string().required("Campo obbligatorio"),
    typology: yup.string().nullable().required("Campo obbligatorio"),
  })
}
